import * as msgpack from '@mta/msgpack-js-lib';

export default class RegistrationCredentials {
	constructor(
			/** ExternalUser= */ externalUser = null,
			/** ?string= */ confirmPassword = ''
	) {
		/** @member {ExternalUser} */
		this.externalUser = externalUser;
		/** @member {?string} */
		this.confirmPassword = confirmPassword;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			externalUser: os.writeObject(this.externalUser),
			confirmPassword: os.writeString(this.confirmPassword)
		};
	}

	/**
	 * @param {!object} is
	 * @param {RegistrationCredentials} value
	 */
	unpack(is, value) {
		if (value.externalUser !== undefined)
			this.externalUser = is.readObject(value.externalUser, () => new msgpack.gen.com.arabellesolutions.sdc.b2b.common.user.ExternalUser());
		if (value.confirmPassword !== undefined)
			this.confirmPassword = is.readString(value.confirmPassword);
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.pub.utils.RegistrationCredentials', RegistrationCredentials);
